import {Record} from "ra-core";
import {
    BooleanField,
    Datagrid,
    DateField,
    FunctionField,
    Link,
    linkToRecord,
    NumberField,
    ReferenceField,
    SelectField,
    TextField,
} from "react-admin";
import {DatagridPropsWithOptions} from "../../shared/types";
import {IdentifierField} from "../../components/IdentifierField";
import {initField} from "../../shared/utils";
import {AssignedField} from "./AssignedField";
import {CreateReminder, LastDateActivity} from "./CreateReminder";
import {useOptions} from "../../shared/hooks/useOptions";
import {InvoiceField} from "../../components/InvoiceField";
import {ShowComment} from "./ShowComment";

export const DebtColletionDatagrid = ({
                                          options,
                                          ...rest
                                      }: DatagridPropsWithOptions) => {
    const {data: optionsInvoice} = useOptions("invoices", "GET");


    return optionsInvoice && (
        <Datagrid {...rest}
                  rowStyle={(record: any) => {
                      return {
                          backgroundColor:
                              record.invoice.type === "NC" ? "#ffff0050" : "white",
                      };
                  }}>
            <IdentifierField show {...initField("id", options)} />
            <FunctionField
                source="assigned"
                render={function (record?: Record | undefined, source?: string) {
                    return record && (
                        <AssignedField record={record}/>
                    );
                }}
                label="Assegnato"
            />



            <FunctionField
                source="date_activity"
                render={function (record?: Record | undefined, source?: string) {
                    return record && (
                        <LastDateActivity row={record}/>
                    )
                }}
                label="Data attività"
            />



            <FunctionField
                source="remainder"
                render={function (record?: Record | undefined, source?: string) {
                    return record && (
                        <CreateReminder row={record}/>
                    )
                }}
                label="Sollecito"
            />

            <FunctionField
                label="Commenti"
                render={(record?: any) => {
                    if (!record) return null;
                    return <ShowComment record={record} />;
                }}
            />

            <FunctionField
                label="Azienda"
                source="invoice.company_object"
                render={(record: Record | undefined) => {
                    if (record && record.invoice.company_object) {
                        return (
                            <Link to={linkToRecord("/subjects", record.invoice.company_object.company.id, "edit")}>
                                <TextField
                                    record={record.invoice.company_object}
                                    source="name"
                                    variant="inherit"
                                />
                            </Link>
                        );
                    }
                    return null;
                }}
                sortBy="invoice__company__company__business_name"
            />
            <FunctionField
                label="Cliente"
                source="invoice.client_id"
                render={(record: Record | undefined) => {
                    if (record) {
                        return (
                            <Link to={linkToRecord("/subjects", record.invoice.client.id, "edit")}>
                                <TextField
                                    record={record.invoice.client}
                                    source="business_name"
                                    variant="inherit"
                                />
                            </Link>
                        );
                    }
                    return null;
                }}
                sortBy="invoice__client__business_name"
            />
            <DateField {...initField("expiration_date", options)} />
            <NumberField {...initField("amount", options)}
                         options={{
                             style: "currency",
                             currency: "EUR",
                         }}/>

            <NumberField
                {...initField("residue", options)}
                label="A saldo"
                options={{
                    style: "currency",
                    currency: "EUR",
                }}
            />

            <TextField {...initField("invoice.terms_payment__method", optionsInvoice)} label="Termini"/>
            <InvoiceField {...initField("invoice", optionsInvoice)} label="Fattura"/>
            <DateField {...initField("invoice.invoice_date", optionsInvoice)} label={"Data fattura"}/>

            <SelectField
                {...initField("invoice.status", optionsInvoice, "array")} label={"Stato fattura"}
                choices={optionsInvoice.status.choices}
            />
            <SelectField
                {...initField("invoice.invoice_type", optionsInvoice, "array")} label={"Tipo fattura"}
                choices={optionsInvoice.invoice_type.choices}
            />
            <SelectField
                {...initField("invoice.type", optionsInvoice, "array")} label={"Tipo (FT/NC)"}
                choices={optionsInvoice.type.choices}
            />
            <TextField {...initField("invoice.email", optionsInvoice)} label={"Email"}/>


        </Datagrid>
    );
};
